import React, { useState, useEffect } from 'react';


const SearchComponent = ({searchedValue,Valuekey}) => {
 const [recentSearches, setRecentSearches] = useState(getStoredSearches());
  
 
  useEffect(() => {
    if (searchedValue) {
      performSearch(searchedValue);
    }
  }, [searchedValue]);

  function getStoredSearches() {
    const storedSearches = JSON.parse(localStorage.getItem(Valuekey)) || [];
    return storedSearches;
  }

  function saveRecentSearches(updatedSearches) {
    setRecentSearches(updatedSearches);
    localStorage.setItem(Valuekey, JSON.stringify(updatedSearches));
  }

  const performSearch = (searchTerm) => {
    if (Valuekey == 'recentWorkOrderSearches') {
        if(searchTerm.WorkOrderId != 0) {
            const updatedSearches = [
            { 
                WorkOrderId : searchTerm.WorkOrderId,
                Status: searchTerm.Status,
                WorkCaseId: searchTerm.WorkCaseId,
                CustomerFullName: searchTerm.CustomerFullName
            },
            ...recentSearches.filter(search => search.WorkOrderId !== searchTerm.WorkOrderId)
            ].slice(0, 20);
            
            saveRecentSearches(updatedSearches);
        }
    }else{
        if(searchTerm.ConsumerId != 0) {
            const updatedSearches = [
            { 
                ConsumerId : searchTerm.ConsumerId,
                CustomerFullName: searchTerm.CustomerFullName,
                City: searchTerm.City,
                PostCode: searchTerm.PostCode
            },
                ...recentSearches.filter(search => search.ConsumerId !== searchTerm.ConsumerId)
            ].slice(0, 20);
            
            saveRecentSearches(updatedSearches);
        }
    }
  };

  return (
    <div></div>
  )

};

export default SearchComponent;